export const ROLES = [
  "super_admin",
  "state_admin",
  "municipal_commissioner",
  "executive_officer",
  "revenue_officer",
  "cashier",
  "tax_inspector",
  "data_entry_operator",
  "citizen",
  "auditor",
  "bank_admin",
];

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  state_admin: "State Administrator",
  municipal_commissioner: "Municipal Commissioner",
  executive_officer: "Executive Officer",
  revenue_officer: "Revenue Officer",
  cashier: "Cashier",
  tax_inspector: "Tax Inspector",
  data_entry_operator: "Data Entry Operator",
  citizen: "Citizen",
  auditor: "Auditor",
  bank_admin: "Bank Administrator",
};

export const isOfficer = (role) => role && role !== "citizen";
export const isAdmin = (role) => ["super_admin", "state_admin", "municipal_commissioner"].includes(role);

export function formatINR(n) {
  if (n == null || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function fmtDate(d) {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export function fmtDateTime(d) {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return d;
  }
}
